var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-dialog',{attrs:{"title":"历史温度","visible":_vm.show,"top":"4.45rem","width":"50%"},on:{"update:visible":function($event){_vm.show=$event},"close":_vm.close}},[_c('div',{attrs:{"id":"lineChart"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }